import { likeHeaders } from "@/lib/useLikes";

const API = process.env.REACT_APP_BACKEND_URL;
export const MAX_VIDEO_SECONDS = 30;
export const MAX_VIDEO_BYTES = 50 * 1024 * 1024;
export const MAX_PHOTO_BYTES = 5 * 1024 * 1024;
export const VIDEO_TYPES = ["video/mp4", "video/quicktime", "video/webm", "video/x-m4v", "video/3gpp"];

const post = async (path, { headers = {}, ...init } = {}) => {
  const r = await fetch(`${API}${path}`, { credentials: "include", headers: { ...likeHeaders(), ...headers }, ...init });
  if (!r.ok) throw new Error(`${path} → ${r.status}`);
  return r.json();
};

export async function uploadPhoto(file) {
  const fd = new FormData();
  fd.append("file", file);
  return (await post("/api/reviews/photo", { method: "POST", body: fd })).photo_id;
}

/** Reads the duration of a local video file through a detached <video> element. */
export const videoDuration = (file) => new Promise((resolve) => {
  const el = document.createElement("video");
  el.preload = "metadata";
  el.onloadedmetadata = () => { URL.revokeObjectURL(el.src); resolve(el.duration); };
  el.onerror = () => resolve(NaN);
  el.src = URL.createObjectURL(file);
});

/** Chunked upload (3 MB parts) so the 50 MB limit survives proxies; `onProgress(0..100)`. */
export async function uploadVideo(file, onProgress = () => {}) {
  const { upload_id, chunk_size, chunks } = await post("/api/reviews/video/init", {
    method: "POST", headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ content_type: file.type, size: file.size }),
  });
  for (let i = 0; i < chunks; i++) {
    await post(`/api/reviews/video/${upload_id}/chunk/${i}`, {
      method: "PUT", headers: { "Content-Type": "application/octet-stream" },
      body: file.slice(i * chunk_size, (i + 1) * chunk_size),
    });
    onProgress(Math.round(((i + 1) / chunks) * 90));
  }
  const done = await post(`/api/reviews/video/${upload_id}/complete`, { method: "POST" });
  onProgress(100);
  return done.video_id;
}
